import Vue from 'vue'
import VueI18n from 'vue-i18n'
import querystring from 'querystring'
import storage from '@/libraries/storage'
import { loading } from '@/libraries/nprogress'
import dict from 'ncovjp-data/lang-jp.i18n.json'

const DEFAULT_LOCALE = 'jp'

const qs = querystring.parse(window.location.search.slice(1))

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: DEFAULT_LOCALE,
  fallbackLocale: 'jp',
  messages: {
    jp: dict,
  },
})

const init = async () => {
  const specified = storage.get('setting.locale') || qs.lang
  if (specified) {
    await changeLocale(specified)
  }
}
init()

export default i18n

export async function changeLocale (locale) {
  const checkLocaleIsLoaded = (locale) => !!Object.keys(i18n.getLocaleMessage(locale)).length
  const change = (locale) => {
    storage.set('setting.locale', locale)
    i18n.locale = locale
  }
  if (i18n.locale === locale) {
    return
  }
  if (checkLocaleIsLoaded(locale)) {
    change(locale)
    return
  }
  let loaded = loading()
  let dict = await import(`ncovjp-data/lang-${locale}.i18n.json`)
  i18n.setLocaleMessage(locale, dict)
  change(locale)
  loaded()
}

